import React from "react";
import "./productCard.scss";
import { Link } from "react-router-dom";
import { Box, CircularProgress, Skeleton } from "@mui/material";

const ProductCardSkeleton = ({ width, height }) => {
  return (
    <Box className="single-product" width={width}>
      <Box component="div" className="product-image">
        <Link style={{ height: height }} className="link">
          <Skeleton animation="wave" variant="rectangular" component="img" />
        </Link>
      </Box>

      <div className="product-basic-details">
        <Link className="link">
          <Skeleton animation="wave">
            <p className="product-title">Title</p>
          </Skeleton>

          <div className="product-price">
            <Skeleton animation="wave">
              <p>₹2520</p>
            </Skeleton>
          </div>
        </Link>
      </div>
    </Box>
  );
};

export default ProductCardSkeleton;
